export default __webpack_public_path__ + "assets/images/296ea1ac1e33680a35b26df780a49d98.svg";